import { render, staticRenderFns } from "./Tempat.vue?vue&type=template&id=0912a101&scoped=true"
import script from "./Tempat.vue?vue&type=script&lang=js"
export * from "./Tempat.vue?vue&type=script&lang=js"
import style0 from "./Tempat.vue?vue&type=style&index=0&id=0912a101&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0912a101",
  null
  
)

export default component.exports